var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 23.511L18.67 4.528a3.095 3.095 0 00-5.338 0L2.4 23.51a2.939 2.939 0 000 2.965A3.043 3.043 0 005.07 28h21.862a3.044 3.044 0 002.666-1.524 2.94 2.94 0 00.002-2.965zM15 13.001a1 1 0 112 0v5a1 1 0 01-2 0v-5zm1 11a1.5 1.5 0 110-3.002A1.5 1.5 0 0116 24z"
  })));
}
export default SvgWarningFill;